import {
  HTTP_AP_ListMortgageProducts_ForTable_Request_Sort,
  HTTP_AP_ListMortgageProducts_ForTable_Response_MortgageProduct,
} from '@api-new/mortgageservice';
import { MortgageProductTableFilterFormValues } from '@platform/mortgage-product/forms/mortgage-product-table-filter.form';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export const mortgageProductTableFilterDefaults: MortgageProductTableFilterFormValues = {
  lenderIds: [],
  mortgageType: null,
  initialMortgageProductStepInterestRate: { min: null, max: null },
  initialMortgageProductStepInterestRateType: null,
  initialMortgageProductStepEndTermMonths: { min: null, max: null },
  ltvMaximumLtv: { min: null, max: null },
  availableDate: null,
  // NOT implemented filters
  applicantIsAvailableForExistingBorrowerExclusive: null,
  applicantIsAvailableForFirstTimeBuyer: null,
  applicantIsAvailableForNewBorrowerRemortgage: null,
  incentivesFreePropertyValuation: null,
  loanAmountMaximumLoanAmount: null,
  productSupportsGreenMortgageExclusive: null,
  productSupportsOwnershipShareLoan: null,
};

export const mortgageProductTableRowDefinition: TableRowDefinitionModel<
  HTTP_AP_ListMortgageProducts_ForTable_Response_MortgageProduct,
  HTTP_AP_ListMortgageProducts_ForTable_Request_Sort
>[] = [
  {
    columnLabel: 'Name',
    columnKey: 'productName',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '16rem',
      max: '16rem',
    },
  },
  {
    columnLabel: 'Lender',
    columnKey: 'lenderId',
    type: RowDefinitionTypeEnum.LenderLogo,
    width: {
      min: '7.5rem',
      max: '7.5rem',
    },
  },
  {
    columnLabel: 'Product Code',
    columnKey: 'productCode',
    type: RowDefinitionTypeEnum.Text,
    widthPercentage: 10,
    sortKey: 'byProductCode',
  },
  {
    columnLabel: 'Mortgage Type',
    columnKey: 'mortgageType',
    type: RowDefinitionTypeEnum.MortgageType,
    widthPercentage: 10,
  },
  {
    columnLabel: 'Initial Rate',
    type: RowDefinitionTypeEnum.Percent,
    columnKey: 'initialMortgageProductStepInterestRate',
    widthPercentage: 10,
    sortKey: 'byInitialMortgageProductStepInterestRate',
  },
  {
    columnLabel: 'Rate Type',
    columnKey: 'initialMortgageProductStepInterestRateType',
    widthPercentage: 10,
  },
  {
    columnLabel: 'Initial Period',
    type: RowDefinitionTypeEnum.DurationMonths,
    columnKey: 'initialMortgageProductStepEndTermMonths',
    widthPercentage: 10,
    sortKey: 'byInitialMortgageProductStepEndTermMonths',
  },
  {
    columnLabel: 'Max LTV',
    type: RowDefinitionTypeEnum.Percent,
    columnKey: 'ltvMaximumLtv',
    widthPercentage: 10,
    sortKey: 'byLtvMaximumLtv',
  },
];
